module.exports = __webpack_public_path__ + "img/dabad96.jpg";